import React, { FC } from "react";

type UserListingPageProps = {};

export const UserListingPage: FC<UserListingPageProps> = () => {
	return <div>Coming soon...</div>;
};
